module.exports = __webpack_public_path__ + "img/non_veg.4fa19827.png";